import { Component, Input } from '@angular/core';
import { RouterLink } from "@angular/router";
import { ICellRendererParams } from "ag-grid-community";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { IndividualRecord } from '@models/individuals/Individual-record';
import { IndividualVerificationStatus } from "@models/individuals/individual-verification-status";

type CellRendererParams = ICellRendererParams<IndividualRecord> & {
  showIndividualVerification?: boolean;
};

@Component({
  selector: 'app-ag-individual-name',
  standalone: true,
  imports: [RouterLink],
  templateUrl: 'ag-individual-name.component.html',
  styleUrl: 'ag-individual-name.component.scss'
})
export class AgIndividualNameComponent implements ICellRendererAngularComp {
  @Input() name = '';
  @Input() individualId = '';
  @Input() verificationStatus;
  @Input() showIndividualVerification = false;

  readonly IndividualVerificationStatus = IndividualVerificationStatus;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.name = params.data?.getFullName() ?? '';
    this.individualId = params.data?.individualId ?? '';
    this.verificationStatus = params.data?.verificationStatus ?? IndividualVerificationStatus.NotVerified;
    this.showIndividualVerification = params.showIndividualVerification ?? false;

    return true;
  }
}
